<template>
    <v-container grid-list-md fluid class="pb-0 mb-0">
        <v-card class="default_card large mx-0 my-2 pa-2" elevation="0">
            <v-row no-gutters>
                <v-col :cols="enablePublish || enablehUnpublish ? '8' : '10'">
                    <v-btn-back class="mr-4" @click.stop="goBack()" />
                    <span class="headline">
                        {{ title }}
                    </span>
                </v-col>
                <v-col
                    :cols="enablePublish || enablehUnpublish ? '4' : '2'"
                    class="d-flex justify-end"
                >
                    <v-btn-primary
                        rounded
                        block
                        :disabled="isDisabled"
                        @click="upload()"
                        data-cy="DocumentRuleSheet-cta"
                    >
                        {{ patternId ? "Modifier" : "Créer" }}
                    </v-btn-primary>
                    <!-- <v-btn
                        rounded
                        block
                        height="40px"
                        color="secondary"
                        class="gradient rounded-lg ml-2"
                        elevation="0"
                        @click="validationBobby()"
                        v-if="enablePublish"
                        :disabled="isDisabled"
                    >
                        Rendre visible pour tous
                    </v-btn>
                    <v-btn
                        rounded
                        block
                        height="40px"
                        color="secondary"
                        class="gradient rounded-lg ml-2"
                        elevation="0"
                        @click="devalidationBobby()"
                        v-if="enablehUnpublish"
                        :disabled="isDisabled"
                    >
                        Enlever pour tous (sauf créateur)
                    </v-btn> -->
                </v-col>
            </v-row>
        </v-card>
        <div :style="'max-height:' + maxHeight + ';' + 'overflow:auto'">
            <v-card v-if="profile.configuration.accountingRule.read" class="scrolled-card">
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-start align-center pb-2">
                        <h2>Conditions : Fournisseur(s) / Client(s) / Activité(s)</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters class="pt-2">
                    <v-col cols="1" class="d-flex align-center justify-center"> Pour </v-col>
                    <v-col cols="2">
                        <v-select-filled
                            v-model="companyIdentifier"
                            :items="identifyCompaniesBy"
                            :hide-details="true"
                            :readonly="readonly"
                            @update:model-value="emptyConditions()"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="8" class="pl-2">
                        <v-combobox-filled
                            v-model="conditionPropToShow"
                            :label="
                                companyIdentifier === 'activity'
                                    ? 'sur ces activités'
                                    : companyIdentifier === 'siren'
                                      ? 'sur ces siren'
                                      : 'sur ces sociétés'
                            "
                            multiple
                            density="compact"
                            chips
                            :rules="sirenRules"
                            :readonly="companyIdentifier !== 'siren'"
                            @update:model-value="updateConditions()"
                        >
                            <template #chip="{ index }">
                                <v-chip
                                    class="ma-2 pa-2"
                                    closable
                                    close-icon="$close"
                                    @click:close="conditionPropToShow.splice(index, 1)"
                                />
                            </template>
                        </v-combobox-filled>
                    </v-col>
                    <v-col col="1" class="d-flex align-center justify-center pl-2">
                        <template
                            v-if="companyIdentifier === 'siren' || companyIdentifier === 'company'"
                        >
                            <v-btn-ternary
                                size="x-small"
                                fab
                                elevation="0"
                                @click="dialogSelectCondition = !dialogSelectCondition"
                                icon="$fa-building"
                            >
                            </v-btn-ternary>
                        </template>
                        <template v-else>
                            <oss-company-activities-selector
                                v-model="activitiesSelected"
                                :multiple="true"
                                :button="true"
                            />
                        </template>
                    </v-col>
                </v-row>
                <v-row no-gutters class="py-4"><v-divider /></v-row>
                <v-row no-gutters class="my-3">
                    <v-col cols="12" class="d-flex justify-start align-center">
                        <h3>Compte tiers</h3>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="2" class="d-flex align-center">
                        <v-switch
                            v-model="withThirdParty"
                            label="Activer"
                            :readonly="readonly"
                            @update:model-value="resetTP"
                        />
                    </v-col>
                    <v-col cols="5" v-if="assignedCompanyCount !== 1 || !uniqueAssignedCompanyId">
                        <AccountableAccount
                            v-show="true"
                            :btnMode="false"
                            :label="' '"
                            :showValidation="false"
                            :showDescription="true"
                            :inAccountableAccounts="accountableAccountsCFSTF"
                            :inAccountableAccount="
                                specs.rules && specs.rules.thirdPartyAccountableAccount
                            "
                            :disabled="!withThirdParty || readonly"
                            :hideDetails="true"
                            @select-accountableAccount="selectThirdPartyAccountableAccount"
                            :defineThirdParty="true"
                        />
                    </v-col>
                    <v-col cols="5" v-else>
                        <AccountableAccount
                            v-show="true"
                            :btnMode="false"
                            :label="' '"
                            :showValidation="false"
                            :showDescription="true"
                            :companyId="uniqueAssignedCompanyId"
                            :inAccountableAccounts="accountableAccountsCFSTF"
                            :inAccountableAccount="
                                specs.rules && specs.rules.thirdPartyAccountableAccount
                            "
                            :disabled="!withThirdParty || readonly"
                            :hideDetails="true"
                            :thirdParty="
                                specs.thirdParty || specs.thirdPartyCompany || specs.thirdPartyUser
                            "
                            :defineThirdParty="true"
                            @select-accountableAccount="selectThirdPartyAccountableAccount"
                        />
                        <!-- data-cy="WordingAnalysisEdition-accountableAccountSpecsThirdPartyOnly" -->
                    </v-col>
                    <v-col cols="5" class="d-flex align-center pl-2">
                        <!-- ThirdPartyCompany -->
                        <v-text-field-filled
                            readonly
                            style="pointer-events: none"
                            label="Tiers"
                            :model-value="thirdPartyTitle"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="my-3">
                    <v-col cols="12" class="d-flex justify-start align-center">
                        <h3>Affectation à un compte de charge ou produit</h3>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="2" class="d-flex align-center">
                        <v-switch
                            v-model="withAccountableAccount"
                            label="Activer"
                            :readonly="readonly"
                            @update:model-value="resetAA"
                        />
                    </v-col>
                    <v-col :cols="10">
                        <AccountableAccount
                            v-show="true"
                            :btnMode="false"
                            :label="' '"
                            :showValidation="false"
                            :showDescription="true"
                            :companyId="uniqueAssignedCompanyId"
                            :inAccountableAccounts="purchaseAndSalesAAs"
                            :inAccountableAccount="specs.rules && specs.rules.accountableAccount"
                            :disabled="!withAccountableAccount || readonly"
                            :hideDetails="true"
                            @select-accountableAccount="selectAccountableAccount"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="py-4"><v-divider /></v-row>
                <v-row no-gutters class="my-3">
                    <v-col cols="12" class="d-flex justify-start align-center">
                        <h3>Étiquettes</h3>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex align-center">
                        <v-combobox-filled
                            v-model="specs.rules.tags"
                            multiple
                            outlined
                            dense
                            chips
                            item-disabled
                        >
                            <template #chip="{ index }">
                                <v-chip
                                    class="ma-2 pa-2"
                                    closable
                                    close-icon="$close"
                                    @click:close="specs.rules.tags.splice(index, 1)"
                                />
                            </template>
                        </v-combobox-filled>
                    </v-col>
                </v-row>
            </v-card>
            <ScopeManager
                ref="scopeManager"
                v-model="scopeSync"
                v-model:id="scopeId"
                v-model:name="scopeName"
                :readonly="readonly"
                :initialCompany="initialCompany"
            />
        </div>
        <v-snackbar v-model="snackbarActive">
            {{ snackbarText }}
            <template v-slot:actions>
                <v-btn @click="snackbarActive = false" variant="text"> Close </v-btn>
            </template>
        </v-snackbar>
        <!-- ThirdPartyCompany -->
        <oss-dialog
            v-model="dialogSelectCondition"
            :title="'Sélectionnez les sociétés tiers'"
            v-if="dialogSelectCondition"
            width="800px"
        >
            <company-table
                :showGenericCompany="false"
                :showNewCompanies="true"
                :wizardMode="true"
                @select-company="companiesSelected"
            >
            </company-table>
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
import { Component, Model, toNative, Vue, Watch, Ref } from "vue-facing-decorator";
import { User } from "../../store/store";

import AccountableAccount from "../AccountableAccount.vue";
import ScopeManager from "../companyScope/ScopeManager.vue";
import CompanyTableComponent from "./CompaniesTable.vue";

import COMPANIES_ACTIVITIES from "../../graphql/CompanyActivities.gql";
import DOCUMENT_RULE from "../../graphql/DocumentRule.gql";
import UPSERT_DOCUMENT_RULE from "../../graphql/UpsertDocumentRule.gql";
import DEFAULT_ACCOUNTABLE_ACCOUNTS from "../../graphql/accountableAccount/DefaultAccountableAccounts.gql";

import OssCompanyActivitiesSelector from "../ossComponents/ossCompanyActivitiesSelector.vue";
import OssCompanySelector from "../ossComponents/ossCompanySelector.vue";

import { Company } from "../../../../types/types";
import { getUserDisplayName } from "../../services/userServices";

/**
 * Document rule add / edit component
 */
@Component({
    components: {
        AccountableAccount,
        companyTable: CompanyTableComponent,
        ScopeManager,
        OssCompanySelector,
        OssCompanyActivitiesSelector,
    },
})
export class DocumentRule extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;
    @Ref() readonly scopeManager!: any;

    /**
     * TRUE if we are in Production (client) view
     * FALSE if we are in GI view */
    get forClient(): boolean {
        return !!this.$store.state.selected_company;
    }

    companyIdentifier = "siren";

    conditionPropToShow = [];

    conditionsList = [];

    dialogSelectCondition = false;

    assignedCompanies = [];

    allAccountingCompany = false;

    scopeSharingStatus = "";

    thirdPartyCompanies = [];

    initialSpecs = null;

    mountedFinished = false;

    snackbarText = "";

    snackbarActive = false;

    validationForAllAccountingCompany = false;

    headers = [{ value: "name" }, { value: "amount" }, { value: "date" }];

    identifyCompaniesBy = [
        { title: "Siren", value: "siren" },
        { title: "Société", value: "company" },
        { title: "Activité", value: "activity" },
    ];

    sirenRules = [];

    activitiesSelected = [];

    initialCompany: Company | null;

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get isRootProfile() {
        if (this.currentUser.isRoot) {
            return true;
        }
        return false;
    }

    get patternId() {
        if (this.$route.params.id) {
            return this.$route.params.id;
        }
        return "";
    }

    get title() {
        let title = "Règle pour ";
        if (!this.name) {
            title +=
                this.companyIdentifier === "siren"
                    ? "Siren"
                    : this.companyIdentifier === "company"
                      ? "Société"
                      : "Activité";
        } else {
            title += this.name;
        }
        return title;
    }

    get name() {
        let regEx = "";
        if (this.conditionsList.length) {
            if (this.conditionsList[0].siren) {
                regEx += this.conditionsList.length.toString() + " Siren(s) : ";
                regEx +=
                    this.conditionPropToShow.slice(0, 2).join(", ") +
                    (this.conditionPropToShow.length > 2 ? ", ..." : "");
            } else if (this.conditionsList[0].companyId) {
                regEx += this.conditionsList.length.toString() + " Société(s) : ";
                if (this.conditionPropToShow.slice(0, 2).join(", ").length < 25) {
                    regEx +=
                        this.conditionPropToShow.slice(0, 2).join(", ") +
                        (this.conditionPropToShow.length > 2 ? ", ..." : "");
                } else {
                    regEx +=
                        this.conditionPropToShow[0] +
                        (this.conditionPropToShow.length > 1 ? ", ..." : "");
                }
            } else if (this.conditionsList[0].activityId) {
                regEx += this.conditionsList.length.toString() + " Activité(s) : ";
                regEx +=
                    this.conditionPropToShow.slice(0, 3).join(", ") +
                    (this.conditionPropToShow.length > 2 ? ", ..." : "");
            }
        }
        return regEx;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get profile() {
        return this.$store.state.user.profile;
    }

    get isDisabled() {
        if (!this.conditionsList.length) {
            return true;
        }
        if (this.readonly) {
            return true;
        }

        if (
            !this.withThirdParty &&
            !this.withAccountableAccount &&
            !this.specs.rules.tags?.length
        ) {
            return true;
        }

        if (this.withThirdParty && !this.specs.rules?.thirdPartyAccountableAccount?.name) {
            return true;
        }

        if (this.withAccountableAccount && !this.specs.rules?.accountableAccount?.name) {
            return true;
        }

        if (
            this.thirdPartyCompanyIsRequired &&
            (!this.specs.thirdPartyCompany || !this.specs.thirdPartyCompany.name)
        ) {
            return true;
        }
        if (
            this.thirdPartyUserIsRequired &&
            (!this.specs.thirdPartyUser || !this.specs.thirdPartyUser.id)
        ) {
            return true;
        }
        if (!this.scopeId && !this.forClient) {
            return true;
        }
        return false;
    }

    get enablePublish() {
        if (this.isRootProfile) {
            if (this.scopeSharingStatus === "PENDING_VALIDATION") {
                return true;
            }
        }
        return false;
    }

    get enablehUnpublish() {
        if (this.isRootProfile) {
            if (this.scopeSharingStatus === "VALIDATE" && this.allAccountingCompany) {
                return true;
            }
        }
        return false;
    }

    get assignedCompanyCount() {
        return this.assignedCompanies.length;
    }

    get uniqueAssignedCompanyId() {
        if (this.assignedCompanies.length === 1) {
            return this.assignedCompanies[0].id;
        }
        return null;
    }

    get thirdPartyTitle() {
        if (this.specs.thirdPartyCompany?.name) {
            return this.specs.thirdPartyCompany.name;
        }
        if (this.specs.thirdPartyUser?.id) {
            return getUserDisplayName(this.specs.thirdPartyUser);
        }
        return "";
    }

    aasWithTPC = ["401000", "401100", "401700", "404000", "404100", "404700", "411000", "411100"];

    get thirdPartyCompanyIsRequired() {
        if (this.withThirdParty) {
            if (this.specs.rules.thirdPartyAccountableAccount?.name) {
                if (
                    this.aasWithTPC.indexOf(this.specs.rules.thirdPartyAccountableAccount.name) !==
                    -1
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    aasWithUser = ["421000", "425000", "455000", "455100", "467000", "467100"];

    get thirdPartyUserIsRequired() {
        if (this.withThirdParty) {
            if (this.specs.rules?.thirdPartyAccountableAccount?.name) {
                if (
                    this.aasWithUser.indexOf(this.specs.rules.thirdPartyAccountableAccount.name) !==
                    -1
                ) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    readonlyTemporaire = false;

    get readonly() {
        if (this.readonlyTemporaire) {
            return true;
        }
        if (!this.profile.configuration.accountingRule.write) {
            return true;
        }
        return false;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (170 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    beforeMount() {
        if (this.forClient) {
            this.initialCompany = this.$store.state?.selected_company;
        }
    }

    goBack() {
        this.$router.go(-1);
    }

    async upload() {
        const rules = {
            accountableAccount: this.addAccountableAccount()
                ? this.specs.rules.accountableAccount
                : null,
            thirdPartyAccountableAccount: this.addThirdPartyAccountableAccount()
                ? this.specs.rules.thirdPartyAccountableAccount
                : null,
            tags: this.specs.rules.tags,
        };

        if (this.scopeManager) {
            await this.scopeManager.createScopeForClient();
        }

        //console.log(Object.keys(this.conditionsList[0])[0], this.conditionsList)
        const result = await this.$apollo.mutate({
            mutation: UPSERT_DOCUMENT_RULE,
            variables: {
                id: this.patternId,
                name: this.title,
                companyScopeId: this.scopeId,
                conditions: this.conditionsList,
                createThirdPartyCompany: this.addThirdPartyCompany
                    ? { connect: { id: this.specs.thirdPartyCompany.id } }
                    : undefined,
                updateThirdPartyCompany: this.addThirdPartyCompany
                    ? { connect: { id: this.specs.thirdPartyCompany.id } }
                    : this.initialSpecs?.thirdPartyCompany
                      ? { disconnect: true }
                      : undefined,
                rules,
            },
        });
        this.$router.go(-1);
    }

    @Apollo({
        query: DEFAULT_ACCOUNTABLE_ACCOUNTS,

        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.defaultAccountableAccounts?.accountableAccounts) {
                    this.defaultAccountableAccounts =
                        data.defaultAccountableAccounts.accountableAccounts;
                }
            }
        },
    })
    defaultAccountableAccounts = [];

    get purchaseAndSalesAAs() {
        return Object.values(this.defaultAccountableAccounts).filter(
            (aa) => aa.name && (aa.name.startsWith("6") || aa.name.startsWith("7")),
        );
    }

    CFSTF = ["Capital", "FixedAssets", "Stocks", "ThirdParty", "Financial"];

    get accountableAccountsCFSTF() {
        return Object.values(this.defaultAccountableAccounts).filter(
            (aa) => this.CFSTF.indexOf(aa.type) !== -1,
        );
    }

    @Apollo({
        query: COMPANIES_ACTIVITIES,
        variables() {
            return {
                where: undefined,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.companyActivities && data.companyActivities.length) {
                    this.companyActivities = data.companyActivities;
                }
            }
        },
    })
    companyActivities = [];

    @Apollo({
        query: DOCUMENT_RULE,
        fetchPolicy: "network-only",
        variables() {
            return { id: this.patternId };
        },
        skip() {
            return this.patternId === null;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.documentRule) {
                    if (data.documentRule.conditions.length) {
                        const firstCondition = data.documentRule.conditions[0];
                        this.companyIdentifier = firstCondition.siren
                            ? "siren"
                            : firstCondition.activityId
                              ? "activity"
                              : "company";
                        this.conditionPropToShow = data.documentRule.conditions.map((x) =>
                            x.siren ? x.siren : x.name,
                        );
                        this.conditionsList = data.documentRule.conditions;
                        this.activitiesSelected = this.companyActivities.filter((act) =>
                            this.conditionPropToShow.includes(act.name),
                        );
                    }

                    const specs = JSON.parse(JSON.stringify(data.documentRule));

                    if (!specs.rules) {
                        specs.rules = {
                            accountableAccount: null,
                            thirdPartyAccountableAccount: null,
                            tags: [],
                        };
                    }

                    this.withThirdParty = !!specs.rules.thirdPartyAccountableAccount;
                    this.withAccountableAccount = !!specs.rules.accountableAccount;

                    if (!specs.thirdPartyCompany) {
                        this.resetThirdPartyCompany(specs);
                    }
                    if (!specs.thirdPartyUser) {
                        this.resetThirdPartyUser(specs);
                    }

                    this.specs = specs;
                    this.initialSpecs = JSON.parse(JSON.stringify(specs));

                    this.scopeName = data.documentRule.companyScope?.name || "";
                    this.scopeId = data.documentRule.companyScope.id;

                    this.assignedCompanies = data.documentRule.companyScope.clients;
                    this.allAccountingCompany = data.documentRule.companyScope.accountingCompany
                        ? false
                        : true;
                    this.scopeSharingStatus = data.documentRule.companyScope.scopeSharingStatus;

                    this.importSuccess = true;
                } else {
                    this.importSuccess = false;
                }
            }
        },
    })
    specs = {
        id: "",
        accountingCompany: {
            id: "",
            name: "",
        },
        accountableAccount: {
            id: "",
            name: "",
            subAccountableAccountOf: null,
        },

        thirdPartyAccountableAccount: {
            id: "",
            name: "",
            displayName: "",
            subAccountableAccountOf: null,
        },
        rules: {
            accountableAccount: null,
            thirdPartyAccountableAccount: null,
            tags: [],
        },
        thirdPartyCompany: {
            id: "",
            name: "",
            parentCompany: null,
        },
        thirdParty: {
            id: "",
            type: "",
            name: "",
            firstname: "",
            lastname: "",
        },
        thirdPartyUser: {
            id: "",
            firstname: "",
            lastname: "",
        },
        company: "",
        //
        scopeSharingStatus: "",
        accountingCompanyOwner: null,
        tags: [],
    };

    importSuccess: boolean = false;

    withThirdParty: boolean = false;
    withAccountableAccount: boolean = false;

    resetTP(e) {
        if (e && this.withAccountableAccount) {
            this.resetAccountableAccount();
        }
        if (!e) {
            this.resetThirdParty();
        }
    }

    resetAA(e) {
        if (e && this.withThirdParty) {
            this.resetThirdParty();
        }
        if (!e) {
            this.resetAccountableAccount();
        }
    }

    resetAccountableAccount() {
        this.withAccountableAccount = false;
        this.specs.rules.accountableAccount = null;
    }

    resetThirdParty() {
        this.withThirdParty = false;
        this.specs.rules.thirdPartyAccountableAccount = null;
        this.resetThirdPartyCompany();
        this.resetThirdPartyUser();
    }

    resetThirdPartyCompany(specs: any = undefined) {
        const localSpecs = specs || this.specs;
        localSpecs.thirdPartyCompany = {
            id: "",
            name: "",
            parentCompany: null,
        };
    }

    resetThirdPartyUser(specs: any = undefined) {
        const localSpecs = specs || this.specs;
        localSpecs.thirdPartyUser = {
            id: "",
            firstname: "",
            lastname: "",
        };
    }

    companiesSelected(company: any) {
        if (
            this.companyIdentifier === "company" &&
            !this.conditionPropToShow.includes(company.name)
        ) {
            this.conditionPropToShow.push(company.name);
            this.conditionsList.push({ companyId: company.id, name: company.name });
        } else if (
            this.companyIdentifier === "siren" &&
            !this.conditionPropToShow.includes(company.siren)
        ) {
            const extractedSiren = company.siren ? company.siren : company.siret.slice(0, 9);
            this.conditionPropToShow.push(extractedSiren);
            this.conditionsList.push({ siren: extractedSiren });
        }
    }

    selectThirdPartyAccountableAccount(data) {
        if (data.accountableAccount.id) {
            delete data.accountableAccount.id;
        }
        this.specs.rules.thirdPartyAccountableAccount = data.accountableAccount;
        // this.specs.thirdParty = data.thirdParty
        if (data.thirdParty) {
            if (data.thirdParty.type === "company") {
                this.specs.thirdPartyCompany = data.thirdParty;
            } else if (data.thirdParty.type === "user") {
                this.specs.thirdPartyUser = data.thirdParty;
            }
        }
        if (!this.thirdPartyCompanyIsRequired) {
            this.resetThirdPartyCompany();
        }
        if (!this.thirdPartyUserIsRequired) {
            this.resetThirdPartyUser();
        }
    }

    selectAccountableAccount(data) {
        if (data.accountableAccount.id) {
            delete data.accountableAccount.id;
        }
        this.specs.rules.accountableAccount = data.accountableAccount;
    }

    updateConditions() {
        if (this.companyIdentifier === "activity") {
            let index;
            this.activitiesSelected.forEach((activity) => {
                if (!this.conditionPropToShow.includes(activity.name))
                    index = this.activitiesSelected.indexOf(activity);
            });
            this.activitiesSelected.splice(1, index);
        }
        if (this.companyIdentifier === "siren") {
            const lastItem = this.conditionPropToShow[this.conditionPropToShow.length - 1];
            if (!this.conditionsList.find((x) => x.siren === lastItem)) {
                this.conditionsList.push({ siren: lastItem });
            }
            this.rules();
            const updatedConditions = this.conditionsList.filter((condition) => {
                return this.conditionPropToShow.includes(condition[this.companyIdentifier]);
            });
            this.conditionsList = updatedConditions;
        }
    }

    // validationBobby() {
    //     this.validationForAllAccountingCompany = true
    //     this.upload()
    // }

    // devalidationBobby() {
    //     this.validationForAllAccountingCompany = false
    //     this.upload()
    // }

    addAccountableAccount() {
        if (this.withAccountableAccount && this.specs.rules?.accountableAccount?.name) {
            return true;
        }
        return false;
    }

    get addThirdPartyCompany() {
        if (this.thirdPartyCompanyIsRequired && this.specs.thirdPartyCompany.id) {
            return true;
        }
        return false;
    }

    addThirdPartyAccountableAccount() {
        if (this.specs.rules?.thirdPartyAccountableAccount?.name) {
            if (
                !this.thirdPartyCompanyIsRequired &&
                this.specs.rules.thirdPartyAccountableAccount.thirdPartyCompany
            ) {
                return false;
            }
            if (
                !this.thirdPartyUserIsRequired &&
                this.specs.rules.thirdPartyAccountableAccount.user
            ) {
                return false;
            }
            return true;
        }
        return false;
    }

    applyingSimulation(anything = false) {}

    emptyConditions() {
        this.conditionsList = [];
        this.conditionPropToShow = [];
        this.activitiesSelected.length = 0;
    }

    rules() {
        const rules = [];
        this.conditionPropToShow.forEach((identifier, index) => {
            let deleteChoice = false;
            if (identifier.length !== 9 && identifier.indexOf(" ") < 0) {
                rules.push("Le Siren doit être composé de 9 chiffres");
                deleteChoice = true;
            }
            if (identifier.indexOf(" ") > 0) {
                rules.push("Entrez le Siren sans espaces");
                deleteChoice = true;
            }
            if (isNaN(identifier) && identifier.indexOf(" ") < 0) {
                rules.push("Le Siren doit être composée uniquement de chiffres");
                deleteChoice = true;
            }
            if (deleteChoice) {
                this.conditionsList.splice(index, 1);
                this.conditionPropToShow.splice(index, 1);
            }
        });

        this.sirenRules = rules;
    }

    @Watch("activitiesSelected")
    onActivitiesSelectedChange(value) {
        if (this.companyIdentifier === "activity" && this.activitiesSelected) {
            this.conditionsList = value.map((activity) => ({
                activityId: activity.id,
                name: activity.name,
            }));
            this.conditionPropToShow = value.map((activity) => activity.name);
        }
    }
}

export default toNative(DocumentRule);
</script>

<style>
.scrolled-card {
    margin-top: 2vh;
    padding: 20px;
    border-radius: 16px;
    margin-top: 8px;
    margin-bottom: 8px;
}
</style>
